import { CSSProperties, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Gender, UserLabels, UserStates } from '@/enums/apiEnums';
import { Leaf } from '@/components/common/svg/shapes/activity-labels/Leaf.tsx';
import { Equalizer } from '@/components/common/svg/shapes/activity-labels/Equalizer.tsx';
import { HeartShape } from '@/components/common/svg/shapes/HeartShape.tsx';

interface UserActivityProps {
  labels: (UserStates | UserLabels)[];
  gender?: Gender;
  isPreview?: boolean;
}

const UserActivity = ({ labels, gender, isPreview }: UserActivityProps) => {
  const { t } = useTranslation();

  const activityLabels = useMemo(
    () => ({
      [UserLabels.LABEL_LIKES_ME]: (
        <span
          style={{ ...textStyle, backgroundColor: '#FF7DA3', color: '#ffffff' }}
        >
          <HeartShape width={11} height={11} fillColor="#ffffff" />
          &nbsp;
          {gender === Gender.MALE
            ? t('discovery.card.activity_status.likes_you.m')
            : t('discovery.card.activity_status.likes_you.f')}
        </span>
      ),
      [UserStates.ONLINE_STATE_UNSPECIFIED]: null,
      [UserStates.ONLINE_STATE_OFFLINE]: null,
      [UserStates.ONLINE_STATE_RECENTLY_SEEN]: null,
      [UserStates.ONLINE_STATE_ONLINE]: (
        <span
          style={{ ...textStyle, backgroundColor: '#FDCB40', color: '#000000' }}
        >
          <Equalizer style={{ marginRight: '3px' }} />
          {t('discovery.card.activity_status.online')}
        </span>
      ),
      [UserLabels.LABEL_JUST_JOINED]: (
        <span style={textStyle}>
          <Leaf style={{ marginRight: '5px', marginTop: '2px' }} />
          {gender === Gender.MALE
            ? t('discovery.card.activity_status.just_joined.m')
            : t('discovery.card.activity_status.just_joined.f')}
        </span>
      )
    }),
    []
  );

  if (isPreview || !labels.length) return null;

  return <div style={containerStyle}>{activityLabels[labels[0]]}</div>;
};

const containerStyle: CSSProperties = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 5,
  left: 15,
  top: 15
};

const textStyle: CSSProperties = {
  backgroundColor: '#A679EB',
  color: '#ffffff',

  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  letterSpacing: '0.05rem',
  fontSize: '11px',
  height: '29px',
  paddingLeft: '10px',
  paddingRight: '12px',
  borderRadius: '12px',
  borderTopLeftRadius: '30px',
  borderTopRightRadius: '8px',
  borderBottomRightRadius: '30px',
  borderBottomLeftRadius: '8px',
  display: 'inline-flex',
  alignItems: 'center'
};

export default UserActivity;
